(function () {
  if (window.__HD_SCROLL_VIDEO_FINAL__) return;
  window.__HD_SCROLL_VIDEO_FINAL__ = true;

  function clamp(v, min, max) {
    return Math.max(min, Math.min(max, v));
  }

  function init(root) {
    if (!root || root.__hdVideoFinal) return;
    root.__hdVideoFinal = true;

    var video = root.querySelector('[data-hd-final-video]');
    var poster = root.querySelector('[data-hd-final-poster]');
    var layers = Array.prototype.slice.call(root.querySelectorAll('[data-hd-final-layer]'));
    var scrim = root.querySelector('[data-hd-final-scrim]');
    if (!video) return;

    var activeFollowMs = Number(root.dataset.activeFollowMs) || 35;
    var releaseFollowMs = Number(root.dataset.releaseFollowMs) || 95;
    var duration = 30;
    var targetProgress = 0;
    var displayProgress = 0;
    var lastProgress = -1;
    var lastScrollAt = performance.now();
    var lastTick = performance.now();
    var raf = 0;
    var destroyed = false;
    var ready = false;
    var lastSeekTime = -10;
    var frameStep = 1 / 24;
    var minSeekDelta = frameStep * 0.45;

    var staticMode = window.matchMedia('(max-width: 767px), (prefers-reduced-motion: reduce)').matches;

    function rawProgress() {
      var rect = root.getBoundingClientRect();
      var travel = Math.max(1, root.offsetHeight - window.innerHeight);
      return clamp(-rect.top / travel, 0, 1);
    }

    function layerOpacity(p, start, end) {
      if (p < start || p > end) return 0;
      var span = Math.max(0.001, end - start);
      var fade = Math.min(0.045, span * 0.28);
      if (start > 0 && p < start + fade) return (p - start) / fade;

      // End-Layer dürfen bis zum letzten Frame sichtbar bleiben.
      if (end >= 0.999) return 1;

      if (p > end - fade) return (end - p) / fade;
      return 1;
    }

    function updateUi(p) {
      for (var i = 0; i < layers.length; i++) {
        var el = layers[i];
        var start = Number(el.dataset.start);
        var end = Number(el.dataset.end);
        var opacity = clamp(layerOpacity(p, start, end), 0, 1);
        el.style.opacity = opacity.toFixed(3);
        el.style.transform = 'translate3d(0,' + ((1 - opacity) * 14).toFixed(1) + 'px,0)';
        el.classList.toggle('is-visible', opacity > 0.05);
      }

      if (scrim) {
        var scrimOpacity = p < 0.86 ? 1 : clamp((0.97 - p) / 0.11, 0, 1);
        scrim.style.opacity = scrimOpacity.toFixed(3);
      }
      root.classList.toggle('is-scrolled', p > 0.025);
    }

    function seekToProgress(p, force) {
      if (!ready || !isFinite(duration) || duration <= 0) return;
      var t = clamp(p, 0, 1) * Math.max(0, duration - 0.001);
      if (!force && Math.abs(t - lastSeekTime) < minSeekDelta) return;
      lastSeekTime = t;
      try {
        video.currentTime = t;
      } catch (e) {
        root.dataset.hdStatus = 'seek-error';
      }
    }

    function tick(now) {
      if (destroyed) return;

      var dt = Math.min(0.05, Math.max(0.001, (now - lastTick) / 1000));
      lastTick = now;
      var active = now - lastScrollAt < 90;
      var tau = Math.max(0.001, (active ? activeFollowMs : releaseFollowMs) / 1000);
      var alpha = 1 - Math.exp(-dt / tau);
      displayProgress += (targetProgress - displayProgress) * alpha;

      if (Math.abs(targetProgress - displayProgress) < 0.00006) {
        displayProgress = targetProgress;
      }

      if (Math.abs(displayProgress - lastProgress) > 0.00001) {
        updateUi(displayProgress);
        seekToProgress(displayProgress, false);
        lastProgress = displayProgress;
      }

      if (displayProgress !== targetProgress || now - lastScrollAt < 170) {
        raf = requestAnimationFrame(tick);
      } else {
        raf = 0;
      }
    }

    function scheduleFromScroll() {
      targetProgress = rawProgress();
      lastScrollAt = performance.now();
      if (!raf) {
        lastTick = performance.now();
        raf = requestAnimationFrame(tick);
      }
    }

    function markReady() {
      if (ready) return;
      duration = Number(video.duration) || 30;
      ready = true;
      root.dataset.hdStatus = 'ready';
      root.classList.add('is-video-ready');
      targetProgress = displayProgress = rawProgress();
      updateUi(displayProgress);
      seekToProgress(displayProgress, true);

      // Warm the decoder without starting playback.
      try {
        video.pause();
        video.muted = true;
        video.playsInline = true;
      } catch (e) {}
    }

    function onCanShowFrame() {
      root.classList.add('has-video-frame');
      if (poster) poster.setAttribute('aria-hidden', 'true');
    }

    if (staticMode) {
      root.dataset.hdStatus = 'static';
      updateUi(0);
      return;
    }

    video.muted = true;
    video.playsInline = true;
    video.preload = 'auto';
    video.pause();

    if (video.readyState >= 1) markReady();
    else video.addEventListener('loadedmetadata', markReady, { once: true });

    if (video.readyState >= 2) onCanShowFrame();
    else {
      video.addEventListener('loadeddata', onCanShowFrame, { once: true });
      video.addEventListener('seeked', onCanShowFrame, { once: true });
    }

    video.addEventListener('error', function () {
      root.dataset.hdStatus = 'video-error';
    });

    targetProgress = displayProgress = rawProgress();
    updateUi(displayProgress);
    window.addEventListener('scroll', scheduleFromScroll, { passive: true });
    window.addEventListener('resize', scheduleFromScroll, { passive: true });

    root.__hdCleanup = function () {
      destroyed = true;
      window.removeEventListener('scroll', scheduleFromScroll);
      window.removeEventListener('resize', scheduleFromScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('[data-hd-scroll-final]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-hd-scroll-final]') : null;
    if (root && root.__hdCleanup) root.__hdCleanup();
  });
})();
